import Component from "../abstracts/Component";
import TrackingComponent from "./TrackingComponent";
import queryString from 'query-string';
import {buildFullQuery, listingLayoutParams, sortByParams} from "../utils/SearchUrlUtil";
import {getQueryParameterByName} from "../utils/Utils";
import {getFocusElement, hasFocusElement, replacePageInHistory} from "../utils/BrowserHistoryUtils";

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-filters]',
      filtersDropdown: '.js-filter-dropdown',
      filterTrigger: '.js-trigger-filter',
      filterList: '.filter-list-checks',
      filtersSection: '.filters',
      resetFilter: '.js-reset-filter',
      facetFiltersBadge: '.js-facet-count',
      filtersCount: '.js-filters-count',
      filterSort: '.js-sort-filter',
      filterClose: '.js-filter-close',
      pagersContainer: '.js-item-pagination',
    }
  }

  get CLASSES() {
    return {
      active: 'is-active',
      layerVisible: 'layer-visible',
      visible: 'is-visible',
      isFiltered: 'is-filtered',
      menuHidden: 'hidden',
      hide: 'd-none',
      filterCheckbox: 'js-filters-checkbox',
      show: 'show',
      sizeGuide: 'size-guide',
    }
  }

  static get CONSTANT() {
    return {
      fakeFilterSuffix: '-fake',
    };
  }

  constructor() {
    super();
    this.sortBy = '';
    this.sortMethod = '';
    this.sortName = '';
    this.sortType = '';
    this.listingLayout = '';
    this.page = 0;
    this.main = document.querySelector(this.SELECTORS.main);
    this.trigger = document.querySelector(this.main.dataset.filtersTrigger);
    this.TrackingComponent = new TrackingComponent();
  }

  forceClose() {
    if (this.trigger) {
      this.trigger.classList.remove(this.CLASSES.active);
    }
    this.main.classList.remove(this.CLASSES.layerVisible);
    if (this.$matchMedia('sm', null)) {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
  }

  toggleFiltersLayer() {
    this.trigger.classList.add(this.CLASSES.active);
    this.main.classList.add(this.CLASSES.layerVisible);

    if (this.$matchMedia('sm', null)) {
      document.body.style.overflow = this.main.classList.contains(this.CLASSES.layerVisible) ? 'hidden' : '';
      document.documentElement.style.overflow = this.main.classList.contains(this.CLASSES.layerVisible) ? 'hidden' : '';
    }

    if (this.main.classList.contains(this.CLASSES.layerVisible)) {
      setTimeout(() => {
        document.querySelector(`${this.main.dataset.filtersLayer} input[type="checkbox"]`).focus();
      }, 200);

      this.$on('keyup.filtersLayer', ({event}) => {
        if (event.which === 27) {
          this.forceClose();
          setTimeout(() => {
            document.querySelector(this.main.dataset.filtersTrigger).focus();
            this.$off('keyup.filtersLayer', this.main.dataset.filtersForm);
          }, 200);
        }
      }, this.main.dataset.filtersForm);
    }

    return this.$customEvents.BACKDROP_EVENTS[`${this.main.classList.contains(this.CLASSES.layerVisible) ? 'show' : 'hide'}`]
  }

  getPage(query, showLoader = true, emitQuery = true, pagequery = '',skipScroll=false) {
    this.sortBy = sortByParams(this.sortBy);
    this.listingLayout = listingLayoutParams(this.listingLayout);
    let fullQuery = '';
    let filterNames = query ? query.split(',').map(filter => filter.split(':')[0]) : [];
    let pathFilter = filterNames.find(filterName => this.main.baseURI.includes(filterName));
    const pathFilterIdx = this.main.baseURI.indexOf(pathFilter);
    const queryIndex = this.main.baseURI.indexOf('?');
    // not the best solution but it works
    if (document.querySelector('body').classList.contains('t-salesV2')) {
      let pageNumber = getQueryParameterByName("page");
      fullQuery = '?'+(pageNumber != null ? 'page='+pageNumber+'&': '')+''+this.listingLayout+'=true';
    } else {
      fullQuery = buildFullQuery({
        textSearch: this.main.dataset.filtersTextsearch,
        query,
        size: this.main.dataset.filtersPagesize,
        page: pagequery,
        sortBy: this.sortBy,
        listingLayout: this.listingLayout
      });
    }

    const ajaxConf = {
      type: 'GET',
      url: pathFilter && (pathFilterIdx < (queryIndex == -1 ? pathFilterIdx+1 : queryIndex)) ? (this.main.baseURI.split(pathFilter)[0] + fullQuery) : fullQuery,
    };

    if (emitQuery) ajaxConf.success = () => {
      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {query: pathFilter && (queryIndex == -1) ? this.main.baseURI.split(pathFilter)[0] + fullQuery : fullQuery,skipScroll});
    }

    if (showLoader) ajaxConf.beforeSend = () => this.$emit(this.$customEvents.LOADER_EVENTS.show);

    return $.ajax(ajaxConf);
  }

  buildQuery() {
    let replaceString = new RegExp('[=\&]', 'g');
    return $(this.main.dataset.filtersForm).serialize().replace(replaceString, ':');
  }

  renderPage(res, append,skipProductRefresh) {
    let response = new DOMParser().parseFromString(res, 'text/html');
    let url = response.URL;
    this.main = document.querySelector(this.SELECTORS.main);
    let container = document.querySelector(this.main.dataset.filtersResult);
    let filtersSelectedContainer = document.querySelector(this.main.dataset.filtersSelected);
    let responseResult = response.querySelector(this.main.dataset.filtersResult);
    let responseFiltersSelected = response.querySelector(this.main.dataset.filtersSelected);
    let infiniteScrollButton = document.querySelector('[data-infinite-scroll]');
    this.focusTimeout = null;
    const pageSupportsPagination=$(this.SELECTORS.pagersContainer).length > 0;
    const newURL = url.replace("isRefineSearch=true", "isRefineSearch=false");
    replacePageInHistory(newURL.replace(/\s.*/, ""),{},"", false);
    let sortBy = response.querySelector(this.SELECTORS.filterSort);
    this.sortMethod = sortBy.dataset.sortMethod;
    this.sortType = sortBy.dataset.sortType;
    // sales refactoring
    let productsCounter = response.querySelector('[data-products-count]');
    if (productsCounter != null) {
      let newProductsCount = productsCounter.getAttribute('data-products-count');
      document.querySelector('[data-products-count]').innerHTML = newProductsCount;
      let mobileCounter = document.querySelector('.products-count.mobile');
      if (mobileCounter != null) {
        mobileCounter.innerHTML = newProductsCount;
      }
    }

    if (infiniteScrollButton) {
      let parsedQuery = queryString.parse(infiniteScrollButton.dataset.infiniteScrollQuery);
      parsedQuery.page = parseFloat(parsedQuery.page) + 1;
      document.querySelector('[data-infinite-scroll]').setAttribute('data-infinite-scroll-query', `?${queryString.stringify(parsedQuery)}`); // next page
      // update number of filtered products
      if (response.querySelector('[data-infinite-scroll]')) {
        document.querySelector('[data-infinite-scroll]').innerHTML = response.querySelector('[data-infinite-scroll]').innerHTML;
      }
    } else if(pageSupportsPagination){
      this.updatePager(response);
    }

    if (append) {
      clearTimeout(this.focusTimeout);
      let rows = responseResult.querySelectorAll('.products-row');
      rows.forEach(child => {
        container.append(child);
      });


    } else {

      if(!skipProductRefresh) {
        if (responseResult.innerHTML !== '') {
          container.innerHTML = responseResult.innerHTML;
        }
      }

      // se ci sono filtri e il container è visibile li aggiungo
      if (responseFiltersSelected) {
        filtersSelectedContainer.parentElement.classList.add(this.CLASSES.visible);
        this.main.classList.add(this.CLASSES.isFiltered);
        filtersSelectedContainer.innerHTML = responseFiltersSelected.innerHTML;
      } else {
        const filtersCount = document.querySelector(this.main.dataset.filtersCount);
        filtersSelectedContainer.parentElement.classList.remove(this.CLASSES.visible);
        this.main.classList.remove(this.CLASSES.isFiltered);
      }
      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {
        updatedButton: infiniteScrollButton ? infiniteScrollButton.parentElement.innerHTML : false,
        hideButton: !response.querySelector('[data-infinite-scroll]')
      });
    }

    this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded, {
      response: response,
      res: res
    });
    this.$emit(this.$customEvents.LOADER_EVENTS.hide);
  }

  updatePager(responseResult) {
    const $html = $(responseResult);
    const pagersContainer = this.SELECTORS.pagersContainer;
    const newPagination = $html.find(pagersContainer);
    const $oldPagination = $(pagersContainer);
    $oldPagination.empty().append(newPagination.children())
  }

  bindFilters() {
    const triggers = document.querySelectorAll(this.SELECTORS.filterTrigger);

    if(triggers.length > 0) {
      // Close all filters dropdown
      document.addEventListener("click", (event) => {
        if (event.target.classList.contains(this.CLASSES.filterCheckbox) || event.target.classList.contains(this.CLASSES.sizeGuide)
          || event.target.classList.contains('vex') || event.target.classList.contains('vex-close') || event.target.classList.contains('toggler')) // prevent closing filter on modal's clicks
          return; // Prevent to close on filter click

        this.closeAllFilter();
      });

      triggers.forEach((trigger) => {
        //width of the dropdown menu title
        let rectW = trigger.getBoundingClientRect().width;
        //minimum width that the dropdown menu must have
        let dropdownMinWidth = 210;
        //creating custom properties to stylize filter dropdown
        trigger.style.setProperty('--dropdown-title-width', rectW + "px");
        if (rectW > dropdownMinWidth) {
          dropdownMinWidth = rectW;
        }
        trigger.style.setProperty('--dropdown-min-width', dropdownMinWidth + "px");

        trigger.addEventListener("click", (event) => {
          if (event.target.classList.contains(this.CLASSES.sizeGuide))
            return; // Prevent stop of propagation on size guide click

          event.stopImmediatePropagation();

          const dropdown = trigger.querySelector(this.SELECTORS.filterList);

          if(dropdown != null) {
            const dropdownStatus = dropdown.classList.contains(this.CLASSES.visible);

            this.closeAllFilter();

            if (!dropdownStatus) {
              dropdown.classList.add(this.CLASSES.visible);
              dropdown.previousSibling.classList.add(this.CLASSES.visible);
            }
          }
        });
      });

      let closeButtons = this.main.querySelectorAll(this.SELECTORS.filterClose);

      if(closeButtons.length > 0) {
        closeButtons.forEach(closeBtn => {
          closeBtn.addEventListener("click", () => {
            this.forceClose();
          });
        });
      }
    }

    const sort = document.querySelector(this.SELECTORS.filterSort);
    if(sort != null) {
      //width of the dropdown menu title
      let rectW = sort.getBoundingClientRect().width;
      //creating custom properties to stylize sort dropdown
      sort.style.setProperty('--dropdown-title-width', rectW + "px");

      sort.addEventListener('click', (event) => {
        event.stopImmediatePropagation();

        const sortStatus = sort.classList.contains(this.CLASSES.show);

        this.closeAllFilter();

        if (!sortStatus) {
          sort.classList.add(this.CLASSES.show);
        }
      });
    }

    this.$on('click.filters', ({event}) => {
      event.preventDefault();
      const zIndex = window.getComputedStyle(this.main).getPropertyValue('z-index');
      this.$emit(this.toggleFiltersLayer(), {
        classes: 'clear',
        zIndex: zIndex - 1
      });
    }, this.main.dataset.filtersTrigger);
  }

  closeAllFilter(){
    // close all filter
    const filters = document.querySelectorAll(this.SELECTORS.filterTrigger),
      sort = document.querySelector(this.SELECTORS.filterSort);

    if(sort.classList.contains(this.CLASSES.show)) {
      sort.classList.remove(this.CLASSES.show);
    }

    if(filters.length > 0) {
      //close all filter
      filters.forEach((filter) => {
        const dropdown = filter.querySelector(this.SELECTORS.filterList);

        if (dropdown.classList.contains(this.CLASSES.visible)) {
          dropdown.classList.remove(this.CLASSES.visible);
          dropdown.previousSibling.classList.remove(this.CLASSES.visible);
        }
      });
    }
  }

  bindEvents() {

    const section = document.querySelector(this.SELECTORS.filtersSection);

    this.$on(this.$customEvents.HEADER_EVENTS.collapsed, () => {
      section.classList.add('reduce-top');
    });

    this.$on(this.$customEvents.HEADER_EVENTS.expanded, () => {
      section.classList.remove('reduce-top');
    });

    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.next, ({payload}) => {
      this.getPage(`${this.buildQuery()}`, true, true, payload.page).then(res => this.renderPage(res, true));
    });

    if (this.$matchMedia('sm', null)) {
      this.$on(this.$customEvents.BURGER_EVENTS.click, ({payload}) => {
        if (payload.menuIn) {
          this.main.classList.add(this.CLASSES.menuHidden);
        } else {
          this.main.classList.remove(this.CLASSES.menuHidden);
        }
      });
    }


    this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.changed, ({payload}) => {
      this.listingLayout = payload.layout;
      this.getPage(this.buildQuery()).then(res => this.renderPage(res)).then(function () {
        let btnScroll = document.querySelector(".js-infinite-scroll");
        if (btnScroll != null) {
          btnScroll.classList.remove("d-none");
        }
      });
    });

    this.$on(this.$customEvents.SORT_BY_EVENTS.changed, ({payload}) => {
      this.sortBy = payload.value;
      this.sortName = payload.name;
      this.getPage(this.buildQuery()).then(res => {
        this.renderPage(res);
        this.TrackingComponent.actions.sortTracking(this.sortName, this.sortMethod, this.sortType);
        FiltersComponent.topFunction()
      });
    });

    this.$on(this.$customEvents.BACKDROP_EVENTS.hidden, this.forceClose(), this.main.dataset.filtersTrigger);

    this.$on('click.filtersReset', () => {
      this.getPage().then(res => {
        let buttonHtml;
        const filtersForm = document.querySelector(this.main.dataset.filtersLayer);
        const responsePage = new DOMParser().parseFromString(res, 'text/html');
        const respoonseFilters = responsePage.querySelector(this.main.dataset.filtersLayer);

        if (responsePage.querySelector('[data-infinite-scroll]')) {
          buttonHtml = responsePage.querySelector('[data-infinite-scroll]').parentElement.innerHTML;
        }


        // reset all checkbox on reset
        filtersForm.innerHTML = respoonseFilters.innerHTML;

        let closeButtonsIntoLayer = filtersForm.querySelectorAll(this.SELECTORS.filterClose);

        if(closeButtonsIntoLayer.length > 0) {
          closeButtonsIntoLayer.forEach(closeBtn => {
            closeBtn.addEventListener("click", () => {
              this.forceClose();
            });
          });
        }

        for (let checkbox of document.querySelectorAll(this.main.dataset.filtersCheckbox)) {
          checkbox.parentElement.parentElement.classList.remove('disabled');
          checkbox.checked = false;
          checkbox.disabled = false;
        }

        //reset badge
        for(let facetBadge of document.querySelectorAll(this.SELECTORS.facetFiltersBadge)) {
          facetBadge.innerText = 0;
          facetBadge.classList.remove(this.CLASSES.visible);
          if (facetBadge.nextElementSibling != null) { // precautions
            facetBadge.nextElementSibling.classList.remove(this.CLASSES.hide);
          }
        }

        document.querySelector(this.SELECTORS.filtersCount).classList.remove(this.CLASSES.visible);

        // hide reset bonus
        document.querySelector(this.SELECTORS.resetFilter).classList.add('d-none');

        let dataInfiniteScroll = document.querySelector('[data-infinite-scroll]');
        if (dataInfiniteScroll) {
          dataInfiniteScroll.classList.remove('d-none');
          dataInfiniteScroll.style.display = '';
        }

        this.renderPage(res);
        this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {updatedButton: buttonHtml,response: res});
        FiltersComponent.topFunction();
      });
    }, document.body, this.main.dataset.filtersReset);

    this.$on('change.filters', ({event,payload}) => {

      let dataInfiniteScroll = document.querySelector('[data-infinite-scroll]');
      if (dataInfiniteScroll) {
        dataInfiniteScroll.classList.remove('d-none');
        dataInfiniteScroll.style.display = '';
      }

      let query = this.buildQuery();

      let checkboxId = '', realCheckbox, fakeCheckbox;

      if(event.target && event.target.id.includes(FiltersComponent.CONSTANT.fakeFilterSuffix)) {
        fakeCheckbox = event.target;
        checkboxId = '#' + fakeCheckbox.id.replace(FiltersComponent.CONSTANT.fakeFilterSuffix, ''); // Find the id of the real filter checkbox
        realCheckbox = document.querySelector(checkboxId);

        if((fakeCheckbox.checked && !realCheckbox.checked) || (!fakeCheckbox.checked && realCheckbox.checked)) {
          realCheckbox.click();
        }
        return; // Prevent filter search by fake filters. For avoid double search
      }else{
        try {
          realCheckbox = event.target;
          checkboxId = '#' + realCheckbox.id + FiltersComponent.CONSTANT.fakeFilterSuffix;
          fakeCheckbox = document.querySelector(checkboxId);
          fakeCheckbox.checked = realCheckbox.checked;
        }catch (e) {
          // fake checkbox not found
        }
      }

      this.TrackingComponent.actions.filterTracking(realCheckbox);

      const {page,$focusElement,skipProductRefresh,skipScroll} = payload || {}

      this.getPage(`${query}`, false, true,page,skipScroll).then(res => {
        const response = new DOMParser().parseFromString(res, 'text/html');
        const originalCheckboxes = document.querySelectorAll(this.main.dataset.filtersCheckbox);

        let selectedCheckboxCounter = {};

        for (let checkbox of originalCheckboxes) {
          const testEl = response.querySelector(`#${checkbox.id}`);

          if (!testEl) {
            checkbox.parentElement.parentElement.classList.add('disabled');
            checkbox.checked = false;
            checkbox.disabled = true;
          } else {
            checkbox.parentElement.parentElement.classList.remove('disabled');
            checkbox.disabled = false;
          }

          if(checkbox.checked === true && checkbox.id.includes(FiltersComponent.CONSTANT.fakeFilterSuffix))
          {
            let facet = checkbox.dataset.facetCode;

            selectedCheckboxCounter[facet] = selectedCheckboxCounter[facet] || [];
            selectedCheckboxCounter[facet].push(checkbox);
            // I only count real checkbox
          }
        }

        this.renderPage(res,false,skipProductRefresh);

        // Hide or Show Reset Button
        const resetBtn = document.querySelector(this.SELECTORS.resetFilter);

        if(!(Object.entries(selectedCheckboxCounter).length === 0 && selectedCheckboxCounter.constructor === Object)){
          resetBtn.classList.remove('d-none');
        }else{
          resetBtn.classList.add('d-none');
        }

        // Hide or Show Badge
        const facetsBadge = document.querySelectorAll(this.SELECTORS.facetFiltersBadge);
        let counter = 0;

        for(let facetBadge of facetsBadge) {
          const facetCounter = (selectedCheckboxCounter[facetBadge.dataset.facetCode] || []).length;

          counter += facetCounter;

          facetBadge.innerText = facetCounter;

          if(facetCounter > 0){
            facetBadge.classList.add(this.CLASSES.visible);
            facetBadge.nextElementSibling.classList.add(this.CLASSES.hide);
          }else{
            facetBadge.classList.remove(this.CLASSES.visible);
            facetBadge.nextElementSibling.classList.remove(this.CLASSES.hide);
          }
        }

        //Hide or show mobile badge
        const mobileBadge = document.querySelector(this.SELECTORS.filtersCount);
        if(counter > 0) {
          mobileBadge.innerHTML = counter;
          mobileBadge.classList.add(this.CLASSES.visible);
        }else{
          mobileBadge.classList.remove(this.CLASSES.visible);
        }

        // if(! $focusElement.length > 0){ i don't know but i hope this...
        if(typeof $focusElement === 'undefined'){
          FiltersComponent.topFunction();
        }else{
          this.timedOutScrollToElement($focusElement);
        }

      });

    }, 'body', this.main.dataset.filtersCheckbox);

    if (!this.$matchMedia('sm', null)) {
      this.$on('click.filtersRemove', ({event}) => {
        const checkboxValue = event.currentTarget.dataset.filtersValue;
        const checkbox = document.querySelector(`input[value="${checkboxValue}"]`);
        if (checkbox) {
          checkbox.checked = false;
          $(checkbox).trigger('change.filters');
          $(this.main.dataset.filtersLayer).trigger('submit.filters');
        }
      }, 'body', this.main.dataset.filtersRemove);
    }

    $(document).ready(() =>{
      const checkboxes = [...document.querySelectorAll(this.main.dataset.filtersCheckbox)];
      const originalCheckboxes = checkboxes.filter((checkbox) => {
        return !checkbox.id.includes(FiltersComponent.CONSTANT.fakeFilterSuffix) && checkbox.checked === true
      });

      let paginationPayload;
      const $focusElement = $(getFocusElement());
      const handleFocus = hasFocusElement() && $focusElement.length > 0;

      paginationPayload = [
        {
          page: getQueryParameterByName("page"),
          skipProductRefresh: true,
          $focusElement,
          skipScroll:true
        }
      ];

      if(originalCheckboxes.length>0){
        $(originalCheckboxes[0]).trigger(
          'change.filters',
          paginationPayload
        );
      } else if (handleFocus) {
        this.timedOutScrollToElement($focusElement);
      }
    });
  }

  timedOutScrollToElement($element) {
    setTimeout(()=> {
      this.scrollToElement($element);
    },500)
  }

  scrollToElement($element) {
    if (typeof $element !== 'undefined' && $element.length > 0) {
      $element.get(0).scrollIntoView({block: "center", inline: "nearest", behavior: "smooth"});
    }
  }

  bindSubmit() {
    this.$on('submit.filters', ({event}) => {
      event.preventDefault();
      this.forceClose();
    }, this.main.dataset.filtersLayer);
  }

  // When the user clicks on filters, scroll to the top of the document
  static topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) {
      this.bindEvents();
      this.bindFilters();
      this.bindSubmit();
    }

    let filtersSelectedContainer = document.querySelector(this.main.dataset.filtersSelected);
    if (filtersSelectedContainer.parentElement.classList.contains(this.CLASSES.visible)) {
      this.main.classList.add(this.CLASSES.isFiltered)
    }
  }
}
